import { stdObject } from "../../../../data/types/stdObject";

export const outstandingBalanceFunc = (salesSection: stdObject) => {
  return "header" in salesSection
    ? salesSection.results.previousBalance +
        (salesSection.results.totals?.TOTAL ?? 0)
    : 0;
};
